module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-plausible/gatsby-browser.js'),
      options: {"plugins":[],"domain":"fromscratchcode.com"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"From Scratch Code","short_name":"From Scratch","description":"Helping quietly ambitious engineers get unstuck and build real things. Rust & Python mentorship, workshops, and project-based learning.","start_url":"/","background_color":"#0460bd","theme_color":"#0460bd","display":"minimal-ui","icon":"static/favicon-512x512.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"950d13d4226aab3bccdde1ace24c331f"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
